var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[16px] mb-[32px]"},_vm._l((_vm.statusItems),function(item,index){return _c('StatusCard',{key:index,attrs:{"value":item.value,"label":item.label,"bgColor":item.bgColor,"isLoading":_vm.isLoading}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }